import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useLang } from '../i18n';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SiteContentContext = createContext({});

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  useEffect(() => {
    let active = true;
    fetch(`${API}/site-content`)
      .then((response) => (response.ok ? response.json() : {}))
      .then((data) => { if (active) setContent(data || {}); })
      .catch(() => { if (active) setContent({}); });
    return () => { active = false; };
  }, []);
  return <SiteContentContext.Provider value={content}>{children}</SiteContentContext.Provider>;
};

export const useSiteContent = (key, fallback = {}) => {
  const all = useContext(SiteContentContext);
  const { lang } = useLang();
  return useMemo(() => {
    const document = all[key];
    if (!document) return fallback;
    const translations = document.translations || {};
    return { ...fallback, ...(translations.pt || {}), ...(translations[lang] || {}), seo: document.seo || {} };
  }, [all, fallback, key, lang]);
};
